import type { BandPriceChipTier } from "@/lib/pricing/sellerPriceBandRecommendations";

export type BandPriceChipStyle = {
  button: string;
  price: string;
  recommendedRing: string;
};

export const BAND_PRICE_CHIP_STYLES: Record<
  BandPriceChipTier,
  BandPriceChipStyle
> = {
  standard: {
    button: "border-primary hover:bg-primary-50 focus:ring-primary",
    price: "text-primary-700",
    recommendedRing: "ring-primary/40",
  },
  sell_sooner: {
    button: "border-sky-300 hover:bg-sky-50 focus:ring-sky-400",
    price: "text-sky-900",
    recommendedRing: "ring-sky-400/50",
  },
  sell_fastest: {
    button: "border-amber-300 hover:bg-amber-50 focus:ring-amber-400",
    price: "text-amber-900",
    recommendedRing: "ring-amber-400/50",
  },
};
